/**
 * Default perspective value for the stage, as aligned with the design.
 */
export const STAGE_INITIAL_PERSPECTIVE = 320;

export const STAGE_ERROR_MESSAGE = "Unfortunately, we weren't able to load this section. Please refresh the page.";
